import { Hero } from "@/components/home/Hero";
import { ClientStrip, ProcessStrip, ProjectsTeaser, SolutionsBento } from "@/components/home/Sections";
import { ComplianceBand, OfferBlock } from "@/components/home/Blocks";
import { CtaBand } from "@/components/site/PageHero";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <ClientStrip />
      <OfferBlock />
      <SolutionsBento />
      <ProjectsTeaser />
      <ProcessStrip />
      <ComplianceBand />
      <CtaBand />
    </div>
  );
}
